import React from "react"
import { Modal, Form, Col, Row, Button } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import DualListBox from "../../components/Administration/DualListBox"
import RegulatoryMode from "../../api/LabService/LabServiceModel/RegulatoryMode"
import ActivateAndInActiveLabAccountObservable from "../../api/Administration/ActivateAndInActiveLabAccount"
import ActionButton from "../ActionButton"
import { APIError } from "../../api/ObservableFromFetch"

interface RegulatoryModeSelectionProps {
  regulatoryModes: RegulatoryMode[]
  selectedRegulatoryModes: RegulatoryMode[]
  show: boolean
  onSave: (regulatoryModes: RegulatoryMode[]) => void
  onClose: () => void
}

interface RegulatoryModeSelectionState {
  show: boolean
  regulatoryModes: RegulatoryMode[]
  selectedRegulatoryModes: RegulatoryMode[]
}

export default class RegulatoryModeSelection extends React.PureComponent<RegulatoryModeSelectionProps, RegulatoryModeSelectionState> {
  state: RegulatoryModeSelectionState = {
    show: this.props.show,
    regulatoryModes: this.props.regulatoryModes,
    selectedRegulatoryModes: this.props.selectedRegulatoryModes
  }


  onCancel = () => {
    this.props.onClose()
  }

  onSubmit = () => {
    const { regulatoryModes, selectedRegulatoryModes } = this.state
    this.props.onSave(selectedRegulatoryModes)
  }

 
  render() {
    const { regulatoryModes, selectedRegulatoryModes } = this.props

    return (
        <Modal backdrop="static" show={this.props.show} size="xl">
          <Modal.Header>
            <Modal.Title className="text-uppercase">Regulatory Modes</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <React.Fragment>
              <Form className="px-4">
                <DualListBox
                  disabled={false}
                  options={regulatoryModes}
                  selected={selectedRegulatoryModes}
                  idKey="RegulatoryModeID"
                  labelKey="Name"
                  availableTitle="Possible Criteria"
                  selectedTitle="Selected Criteria"
                  onChange={selected => this.setState({ selectedRegulatoryModes: [...selected] })}
                />
              </Form>
            </React.Fragment>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.onCancel} className="px-4">Cancel</Button>
            <ActionButton onClick={this.onSubmit} className="px-4">Save</ActionButton>
          </Modal.Footer>
        </Modal>
    )
  }

}
